<div>
    <ws-modal-wrapper headerLabel="Consultants"
                      [suppressKeyboardEvents]="true"
                      (cancel)="done()"
                      [loading]="isLoading"
                      [hideFooter]="true">
        @if ((consultingEngagements.length > 0 || availableConsultants.length > 0) && !isLoading) {
            <div class="float-end header-button-container">
                @if (!isEditMode && !isLoading) {
                    <button class="ace-btn has-icon btn-primary" (click)="toggleEdit()">
                        <i class="fa fa-pencil fa-align"></i>
                    </button>
                }
            </div>
        }
        <!-- no consultants -->
        @if (!isLoading && visualState === 'List' && (consultingEngagements.length === 0 && availableConsultants.length === 0)) {
            <div>
                <h2>There are currently no consultants available</h2>
            </div>
        }
        <!-- consultants table-->
        @if (!isLoading && visualState === 'List' && (consultingEngagements.length > 0 || availableConsultants.length > 0)) {
            <table class="table table-hover">
                <thead>
                    <tr>
                        <th>Company</th>
                        <th>Status</th>
                        <th>@if (this.isEditMode) {
                            <div>Actions</div>
                        }</th>
                    </tr>
                </thead>
                <tbody>
                    <!-- invited/accepted engagments-->
                    @for (engagement of consultingEngagements; track engagement) {
                        <tr>
                            <td>{{ engagement.name }}</td>
                            <td>{{ getEngagementStatus(engagement) }}</td>
                            <td>
                                @if (this.isEditMode) {
                                    <div>
                                        @if (!engagement.accepted) {
                                            <button class="ace-btn btn-sm ace-btn btn-primary"
                                                    (click)="cancelEngagement(engagement.consultingEngagementId)">
                                                Withdraw Request
                                            </button>
                                        }
                                        <button class="ace-btn btn-sm ace-btn btn-primary"
                                                (click)="editEngagement(engagement)">
                                            Edit Permissions
                                        </button>
                                        @if (engagement.accepted) {
                                            <button class="ace-btn btn-sm ace-btn btn-primary"
                                                    (click)="cancelEngagement(engagement.consultingEngagementId)">
                                                Cancel Engagement
                                            </button>
                                        }
                                    </div>
                                }
                            </td>
                        </tr>
                    }
                    <!-- available consultants-->
                    @for (consultant of availableConsultants; track consultant) {
                        <tr>
                            <td>{{ consultant.consultantName }}</td>
                            <td></td>
                            <td>
                                @if (this.isEditMode) {
                                    <div>
                                        <button class="ace-btn btn-sm ace-btn btn-primary" (click)="invite(consultant)">
                                            Invite
                                        </button>
                                    </div>
                                }
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        }

        <!--permissions list - for invite confirm and edits-->
        @if (!isLoading && visualState !== 'List') {
            <div>
                <instance-rights-list (editModeEvent)="editModeEventHander($event)"
                                      [availableInstanceRights]="availableInstanceRights"
                                      [engagement]="selectedEngagement"></instance-rights-list>
                <hr/>
                <div class="float-end">
                    @if (visualState === 'Invite') {
                        <button class="ace-btn btn-sm ace-btn btn-primary" (click)="confirmInvite()">Confirm Invite
                        </button>
                    }
                    @if (visualState === 'Edit') {
                        <button class="ace-btn btn-sm ace-btn btn-primary"
                                (click)="updatePermissions()"
                                [disabled]="permsBeingEdited">
                            Update Permissions
                        </button>
                    }
                    <button class="ace-btn btn-sm ace-btn btn-primary" (click)="cancel()" [disabled]="permsBeingEdited">
                        Cancel
                    </button>
                </div>
            </div>
        }
        @if (visualState === 'List') {
            <div class="float-end">
                <button class="ace-btn btn-primary" (click)="done()" tabindex="0">
                    Close
                </button>
            </div>
        }
    </ws-modal-wrapper>
</div>
